
import { Vue } from "vue-class-component";

export default class PictureFrame extends Vue {}
